<template>
  <!-- 合作条款 -->
  <div id="hzClause" class="clause animate__animated init--zzQhF">
    <div class="clause_box maxWidth">
      <div class="clause_title">
        <div>合作条款</div>
        <div></div>
      </div>
      <div class="clause_main">
        <ul class="clause_ul">
          <li
            v-for="(item, index) in clauseList"
            :class="item.show ? 'clause_li_restore' : 'clause_li_activate'"
            :key="index"
            @mousemove="clause(index)"
          >
            <div class="clause_ul_li">
              <div
                class="clause_ul_li_title"
                :class="item.show ? '' : 'clause_ul_li_title_bg'"
              >
                <div :class="`clause${index}`"></div>
                <div>{{ item.title }}</div>
              </div>
              <div
                class="clause_ul_li_main"
                :class="item.show ? '' : 'clause_ul_li_main_activate'"
              >
                <div>
                  <div v-for="(value, valIndex) in item.info" :key="valIndex">
                    {{ value }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.show" class="clause_ul_shade">
              <div class="clause_ul_shade_box">
                <div :class="`clause${index}`"></div>
                <div>{{ item.title }}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clauseList: [
        //合作案例内容
        {
          title: "合作优势",
          info: [
            "①合作产品可免费入驻《千年游戏盒子》，基于产品品质上线首周获得推荐资源位扶持",
            "②我们拥有众多高完成度游戏版本供开发者选择",
            "③强大的游戏开发引擎和技术服务人员支持个性化内容定制",
            "④专业的技术，运营，市场，客服团队7*24小时全程保驾护航",
            "⑤完善的运营及运维工具让产品成功之路事半功倍",
            "⑥我们拥有《千年》网络游戏中国大陆地区独家代理权,打击权",
            "⑦我们相信只有共同努力，才能打造好千年游戏IP，让广大玩家有更优质的游戏体验",
          ],
          show: false,
        },
        {
          title: "成本支出",
          info: [
            "您可联系授权商务咨询详情"
          ],
          show: true,
        },
        {
          title: "分成收益",
          info: ["您可联系授权商务咨询详情"],
          show: true,
        },
        {
          title: "交付清单",
          info: [
            "①包含登录+支付系统的（IOS+安卓+PC ）三端互通最终游戏版本",
            "②万能渠道后台：集实时查看游戏数据，推广链接分发等功能",
            "③综合后台：集运营数据查看分析，游戏相关特殊信息一键透析",
            "④您专属的7*24小时技术，运营，客服团队全程服务",
          ],
          show: true,
        },
        {
          title: "正式上线",
          info: [
            "①正式上线后我们将持续辅助您做好正式上线后的游戏运营，推广，后续版本迭代服务",
          ],
          show: true,
        },
      ],
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {
    clause(index) {
      this.clauseList.forEach((item, i) => {
        item.show = true;
      });
      this.clauseList[index].show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.clause {
  width: 100%;
  height: 9.65rem /* 772/80 */;
  background: #424242;
}
.clause_box {
  height: 100%;
  background: url("../../assets/images/pc/clause_bg.jpg") no-repeat;
}
.clause_title {
  font-size: 0.45rem /* 36/80 */;
  color: #fff;
  padding-top: 0.775rem /* 62/80 */;
  margin-bottom: 0.3125rem /* 25/80 */;
  font-weight: bold;
  text-align: center;
}

.clause_title > div:nth-child(2) {
  width: 10.875rem /* 870/80 */;
  height: 1px;
  margin: 0 auto;
  margin-top: 0.3125rem /* 25/80 */;
  background: linear-gradient(to right, #383838, #aeaeae 50%, #383838);
}

.clause_main {
  margin: 0 auto;
  margin-top: 1.6375rem /* 131/80 */;
  width: 15.275rem /* 1222/80 */;
}

.clause_ul {
  /* width: 1008px; */
  display: flex;
  justify-content: space-between;
  height: 4.3125rem /* 345/80 */;
}

.clause_ul > li {
  width: 5.475rem /* 438/80 */;
  box-sizing: border-box;
  border-radius: 0.1875rem /* 15/80 */;
  overflow: hidden;
  position: relative;
  margin-right: 0.175rem /* 14/80 */;
  cursor: pointer;
}

.clause_ul_shade {
  position: absolute;
  top: 0;
  left: 0;
  background: #535353;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}

.clause_ul_shade .clause_ul_shade_box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  font-size: 0.3rem /* 24/80 */;
  text-align: center;
  color: #fff;
}

.clause_ul_shade .clause_ul_shade_box > div:nth-child(1) {
  width: 1.2rem /* 96/80 */;
  height: 1rem /* 80/80 */;
  margin: 0 auto;
  margin-bottom: 0.2875rem /* 23/80 */;
  background-size: cover;
}

.clause_ul_li {
  position: relative;
  z-index: 1;
}

.clause_ul > li::after {
  content: "";
  width: 100%;
  height: 100%;
  background: #7b7b7b;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.9;
}

.clause_ul > li + li {
  width: 3rem /* 240/80 */;
}

.clause_ul .clause_li_activate {
  width: 5.475rem /* 438/80 */;
}

.clause_ul .clause_li_restore {
  width: 3rem /* 240/80 */;
}

.clause_ul > li .clause_ul_li_main {
  margin-top: 0.1rem /* 8/80 */;
  padding: 0 0.2625rem /* 21/80 */;
}

.clause_ul_li_title {
  font-size: 0.275rem /* 22/80 */;
  color: #fff;
  padding-left: 0.2625rem /* 21/80 */;
  padding-top: 0.2375rem /* 19/80 */;
  padding-bottom: 0.2rem /* 16/80 */;
  display: flex;
  align-items: center;
}

.clause_ul_li_title_bg {
  background: #962515;
}

.clause_ul_li_title > div:nth-child(1) {
  width: 0.65rem /* 52/80 */;
  height: 0.55rem /* 44/80 */;
  background-size: cover;
}

.clause_ul_li_title > div:nth-child(2) {
  padding-left: 0.1625rem /* 13/80 */;
}

.clause_ul_li_main {
  height: 3.05rem /* 244/80 */;
  font-size: 0.175rem /* 14/80 */;
  color: #fff;
  width: 88%;
  transform-origin: center top;
  transform: scaleY(0);
  transition: 0.5s;
  overflow-y: auto;
}

.clause_ul_li_main_activate {
  transform: scaleY(1);
}

.clause_ul_li_main::-webkit-scrollbar {
  width: 0.05rem /* 4/80 */;
}

.clause_ul_li_main::-webkit-scrollbar-thumb {
  background: #fff;
  /* 滑块颜色 */
  border-radius: 0.025rem /* 2/80 */;
  /* 滑块圆角 */
}

.clause_ul_li_main::-webkit-scrollbar-track {
  border-radius: 0.025rem /* 2/80 */;
  /* 轨道圆角 */
  background-color: #572f2a;
  /* 轨道颜色  */
}

.clause_ul_li_main > div {
  line-height: 0.375rem /* 30/80 */;
}

.clause0 {
  background: url("../../assets/images/pc/clause1.png") no-repeat center;
}

.clause1 {
  background: url("../../assets/images/pc/clause2.png") no-repeat center;
}

.clause2 {
  background: url("../../assets/images/pc/clause3.png") no-repeat center;
}

.clause3 {
  background: url("../../assets/images/pc/clause4.png") no-repeat center;
}

.clause4 {
  background: url("../../assets/images/pc/clause5.png") no-repeat center;
}
</style>


